angular.module('routes.MainController', [
  'stack'
])

/**
 * The Controller manages view logic for the main app
 *
 * @class Controller
 * @constructor
 * @module routes.MainController
 */
.controller('MainController', [
  '$rootScope',
  '$state',
  'QueueService',
  'LoginService',
  function ($rootScope, $state, QueueService, LoginService) {
    'use strict';

    /**
     * Tests storage for user
     *
     * @private
     */
    function checkUser() {
      if (!$rootScope.user) {
        if (
          $state.current.name !== 'routes.login'
          && $state.current.name !== 'routes.notAuthorized'
        ) {
          if ($state.get('routes.login')) {
            $state.go(
              'routes.login',
              $state.params,
              { reload: true, inherit: false, notify: true }
            );
          } else {
            // TODO: Add redirect to protect delivery
            // $state.go('routes.notAuthorized');
            $rootScope.loading = true;
          }
        }
      } else {
        console.log($rootScope.user);
      }
    }

    /**
     * Initializes listeners for selected activity and ngRepeatFinish
     *
     * @private
     */
    function defineListeners() {
      $rootScope.loading = false;

      $rootScope.$on('$stateChangeSuccess', function () {
        $rootScope.loading = false;
        QueueService.processDeferred();
      });

      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        if (!LoginService.getToken() && toState.name !== 'routes.login') {
          if (fromState.name !== 'routes.login' && $state.get('routes.login')) {
            event.preventDefault();
            $state.go(
              'routes.login',
              $state.params,
              { reload: true, inherit: false, notify: true }
            );
          } else {
            // TODO: Add redirect to protect delivery
            // $state.go('routes.notAuthorized');
            $rootScope.loading = true;
          }
        } else {
          // $rootScope.user = UsersService.get(JSON.parse(window.localStorage.newman).user);
          LoginService.checkToken(LoginService.getToken());
          $rootScope.loading = true;
        }
      });
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      checkUser();
      defineListeners();
    }

    initialize();
  }
]);
